module.exports = __webpack_public_path__ + "static/media/ortho-image1@3x.08896114.png";